/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
export const gtmEventTypes = {
  BOOK_TESTDRIVE_CLICK_BOOK_TEST_DRIVE: 'BOOK_TESTDRIVE_BTDF_CLICK_BOOK_TEST_DRIVE',
  BOOK_TESTDRIVE_CLICK_SUBMIT: 'BOOK_TESTDRIVE_BTDF_CLICK_SUBMIT',
  BOOK_TESTDRIVE_SELECT_MODEL: 'BOOK_TESTDRIVE_BTDF_SELECT_MODEL',
  BOOK_TESTDRIVE_SELECT_TITLE: 'BOOK_TESTDRIVE_BTDF_SELECT_TITLE',
  BOOK_TESTDRIVE_ENTER_FIRSTNAME: 'BOOK_TESTDRIVE_BTDF_ENTER_FIRSTNAME',
  BOOK_TESTDRIVE_ENTER_LASTNAME: 'BOOK_TESTDRIVE_BTDF_ENTER_LASTNAME',
  BOOK_TESTDRIVE_ENTER_PHONE: 'BOOK_TESTDRIVE_BTDF_ENTER_PHONE',
  BOOK_TESTDRIVE_ENTER_EMAIL: 'BOOK_TESTDRIVE_BTDF_ENTER_EMAIL',
  BOOK_TESTDRIVE_SELECT_POSTCODE_SUBURB: 'BOOK_TESTDRIVE_BTDF_SELECT_POSTCODE_SUBURB',
  BOOK_TESTDRIVE_DEALER_CLICK_ADDRESS: 'BOOK_TESTDRIVE_BTDF_DEALER_CLICK_ADDRESS',
  BOOK_TESTDRIVE_DEALER_CLICK_WEBSITE: 'BOOK_TESTDRIVE_BTDF_DEALER_CLICK_WEBSITE',
  BOOK_TESTDRIVE_DEALER_CLICK_PHONE: 'BOOK_TESTDRIVE_BTDF_DEALER_CLICK_PHONE',
  BOOK_TESTDRIVE_ENTER_COMMENTS: 'BOOK_TESTDRIVE_BTDF_ENTER_COMMENTS',
  BOOK_TESTDRIVE_CHECK_OPTIN: 'BOOK_TESTDRIVE_BTDF_CHECK_OPTIN',
  BOOK_TESTDRIVE_CHECK_PRIVACY_POLICY: 'BOOK_TESTDRIVE_BTDF_CHECK_PRIVACY_POLICY',
  BOOK_TESTDRIVE_CLICK_PRIVACY_POLICY: 'BOOK_TESTDRIVE_BTDF_CLICK_PRIVACY_POLICY',
  BOOK_TESTDRIVE_CLICK_GO_BACK: 'BOOK_TESTDRIVE_BTDF_CLICK_GO_BACK',
}

// Action creators
export const gtmEvents = {
  [gtmEventTypes.BOOK_TESTDRIVE_CLICK_BOOK_TEST_DRIVE]: ({buttonText = ''}) => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_BOOK_TEST_DRIVE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-001',
    pageCategory: 'Book A Test Drive Form',
    pageAction: `Book A Test Drive Form - Clicked "${buttonText.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_CLICK_SUBMIT]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_SUBMIT,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-002',
    pageCategory: 'Book A Test Drive Form',
    pageAction: `Book A Test Drive Form - Clicked Submitted - "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_SELECT_MODEL]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_SELECT_MODEL,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-003',
    pageCategory: 'Book A Test Drive Form',
    pageAction: `Book A Test Drive Form - Selected "MODEL - "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_SELECT_TITLE]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_SELECT_TITLE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-004',
    pageCategory: 'Book A Test Drive Form',
    pageAction: `Book A Test Drive Form - Selected "TITLE" - "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_ENTER_FIRSTNAME]: () => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_FIRSTNAME,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-005',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "FIRSTNAME"',
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_ENTER_LASTNAME]: () => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_LASTNAME,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-006',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "LASTNAME"',
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_ENTER_PHONE]: () => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_PHONE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-007',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "PHONE"',
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_ENTER_EMAIL]: () => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_EMAIL,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-008',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "EMAIL"',
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_SELECT_POSTCODE_SUBURB]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_SELECT_POSTCODE_SUBURB,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-009',
    pageCategory: 'Book A Test Drive Form',
    pageAction: `Book A Test Drive Form - Selected "POSTCODE/SUBURB" - "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_ADDRESS]: ({dealerName, address}) => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_ADDRESS,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-010',
    pageCategory: 'Book A Test Drive Form',
    pageAction: `Book A Test Drive Form - ${dealerName} - Address "${address}" - Clicked "ADDRESS"`,
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_WEBSITE]: ({dealerName, address, website}) => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_WEBSITE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-011',
    pageCategory: 'Book A Test Drive Form',
    pageAction: `Book A Test Drive Form - ${dealerName} - Address "${address}" - Clicked "WEBSITE ${website}"`,
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_PHONE]: ({dealerName, address, phone}) => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_PHONE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-012',
    pageCategory: 'Book A Test Drive Form',
    pageAction: `Book A Test Drive Form - ${dealerName} - Address ${address} - Clicked "PHONE ${phone}"`,
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_ENTER_COMMENTS]: () => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_COMMENTS,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-013',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "COMMENTS"',
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_CHECK_OPTIN]: () => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_CHECK_OPTIN,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-014',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Checked "OPTIN"',
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_CHECK_PRIVACY_POLICY]: () => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_CHECK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-015',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Checked "PRIVACYPOLICY"',
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_CLICK_PRIVACY_POLICY]: () => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-016',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Clicked "PRIVACYPOLICY"',
  }),
  [gtmEventTypes.BOOK_TESTDRIVE_CLICK_GO_BACK]: () => ({
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_GO_BACK,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-017',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Clicked "GO BACK"',
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/book-testdrive-duck.js